module.exports = __webpack_public_path__ + "static/img/cont3614.43eb7d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3614.jpg
// module id = g5wU
// module chunks = 0